export default __webpack_public_path__ + "files/media/date.6fa956c5.svg";